module.exports = __webpack_public_path__ + "static/media/O49-2500.7c548b3d.jpg";